export var SdkMixin;
(function (SdkMixin) {
    /**
     * Default mixin, will be applied anyways
     */
    SdkMixin["element"] = "element";
    SdkMixin["clickable"] = "clickable";
    SdkMixin["changeable"] = "changeable";
    SdkMixin["focusable"] = "focusable";
    SdkMixin["disableable"] = "disableable";
    SdkMixin["accessible"] = "accessible";
})(SdkMixin || (SdkMixin = {}));
//# sourceMappingURL=types.js.map